import { render } from "./OverviewPanel.vue?vue&type=template&id=0c021fc0&scoped=true"
import script from "./OverviewPanel.vue?vue&type=script&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&lang=js"

import "./OverviewPanel.vue?vue&type=style&index=0&id=0c021fc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c021fc0"]])

export default __exports__